import { Box, styled } from '@mui/material';
import { palette } from '../../theme/palette';

export const StyledPriceLabel = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'useLightBg' && prop !== 'rightAlign' ,
})<{
  useLightBg?: boolean | undefined;
  rightAlign?: boolean | undefined;
}>`
  padding: 0px 15px;
  border-radius: 50px;
  background: ${(props) => (props.useLightBg ? palette.custom.white : palette.custom.lightGrey)};
  color: ${palette.custom.darkGrey};
  text-align: center;
  font-size: 11px;
  font-style: normal;
  font-weight: 800;
  letter-spacing: 0.55px;
  text-transform: uppercase;
  margin: ${(props) => (props.rightAlign ? '0px 0px 0px 10px' : '0px 10px 0px 0px')};
  white-space: nowrap;
`;
